import { ErrorHandler } from '@angular/core';
import { hasHandledUserVisiblePath } from './api-error';

/** True when the transport showed this ApiError; also unwraps zone promise rejections. */
export function wasShownToUser(error: unknown): boolean {
  const rejection = typeof error === 'object' && error !== null && 'rejection' in error
    ? (error as { rejection: unknown }).rejection : undefined;
  return hasHandledUserVisiblePath(error) || hasHandledUserVisiblePath(rejection);
}

/** Monitoring receives unshown failures; a shown API error is an expected outcome. */
export class ShownApiErrorFilter implements ErrorHandler {
  constructor(private readonly next: ErrorHandler) {}
  handleError(error: unknown): void {
    if (!wasShownToUser(error)) this.next.handleError(error);
  }
}
